import { IPolicyType } from "../../../services/api/insurance/coverage/types";
import startCase from "lodash/startCase";

export const selectorPolicyTypeByPolicyType = (
  policyType: IPolicyType
): string => {
  return startCase(policyType);
};
